import _toConsumableArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useQuickAndExpertContext from "contexts/StartPage/useQuickAndExpertContext";
import { ELSNativeSelectOption } from "components/common/elsevier/Select/NativeSelectOption";
import { ELSNativeSelect } from "components/common/elsevier/Select/NativeSelect";
import { selectSessionSettings } from "redux/reducers/sessionSettingsReducer";
import { selectUsersessionData } from "redux/reducers/userSessionReducer";
import { getSelectedDatabases, updateStartYears } from "components/applogic/Databases";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import { ELSFormLabel } from "components/common/elsevier/Form/FormLabel";
import DeleteButton from "components/fragments/Search/shared-components/DeleteButton";
import DateRangeStyles from "./Styles.module.scss";
function Date(_ref) {
  var toggleYearState = _ref.toggleYearState,
    toggleYearRow = _ref.toggleYearRow;
  var sessionSettings = useSelector(selectSessionSettings);
  var userSession = useSelector(selectUsersessionData);
  var userMask = sessionSettings.userMask,
    sort = sessionSettings.sort;
  var userSelectedDBs = getSelectedDatabases(userMask);
  userSelectedDBs = updateStartYears(userSelectedDBs, userSession.userTextZones);
  var _React$useState = React.useState("yearrange"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedOption = _React$useState2[0],
    setSelectedOption = _React$useState2[1];
  var _useQuickAndExpertCon = useQuickAndExpertContext(),
    quickAndExpertState = _useQuickAndExpertCon.quickAndExpertState,
    setQuickAndExpertState = _useQuickAndExpertCon.setQuickAndExpertState,
    clearQuickAndExpertState = _useQuickAndExpertCon.clearQuickAndExpertState;

  // creating a consistence reference variable for the startYearRef by using useRef:
  var startYearRef = useRef();
  useEffect(function () {
    // reset years in quickAndExpertDate
    clearQuickAndExpertState();
    // Reset set to new database mask
    var json = {};
    json.databasemask = userMask;
    json.sort = sort;
    setQuickAndExpertState(json);
  }, [userMask]);

  /*
  Adding a useEffect to check every time startYearRef.current has changed and the toggleYearState were true,
  then run the focus() on the firstChild of the Element which means the select element :
  */
  useEffect(function () {
    if (startYearRef !== null && startYearRef !== void 0 && startYearRef.current && toggleYearState) {
      var _startYearRef$current, _startYearRef$current2;
      startYearRef === null || startYearRef === void 0 ? void 0 : (_startYearRef$current = startYearRef.current) === null || _startYearRef$current === void 0 ? void 0 : (_startYearRef$current2 = _startYearRef$current.firstChild) === null || _startYearRef$current2 === void 0 ? void 0 : _startYearRef$current2.focus();
    }
  }, [startYearRef === null || startYearRef === void 0 ? void 0 : startYearRef.current, toggleYearState]);
  var handleChange = useCallback(function (event) {
    var json = quickAndExpertState;
    json[event.target.name] = event.target.value;
    if (!(json !== null && json !== void 0 && json.yearselect)) {
      json.yearselect = selectedOption;
    }
    setQuickAndExpertState(json);
  }, [setQuickAndExpertState]);
  var getYearRange = function getYearRange(sortType) {
    var years = [];
    // get earliest start year from list of databases
    var minStartYear = Math.min.apply(Math, _toConsumableArray(userSelectedDBs.map(function (item) {
      return item.startyear;
    })));
    // Loop through databases to get the latest end year
    // ibs and zbf don't set end year to endYear text zone
    var holdEndYear = 0;
    userSelectedDBs.forEach(function (item) {
      // only switch if another database using start.page.endYear hasn't been found yet
      if (item.searchcode === "ibs" || item.searchcode === "zbf") {
        holdEndYear = Math.max(item.endyear, holdEndYear);
      } else {
        holdEndYear = userSession.userTextZones["start.page.endYear"];
      }
    });
    for (var _i = minStartYear; _i <= holdEndYear; _i += 1) {
      years.push(_i);
    }
    if (sortType === "desc") {
      years.sort(function (a, b) {
        return b - a;
      });
    }
    return years;
  };
  return /*#__PURE__*/React.createElement(ELSGrid, {
    container: true,
    className: "".concat(DateRangeStyles.row, " ").concat(toggleYearState ? "show-flex" : "hide", " "),
    spacing: 3,
    id: "yearRangeRow"
  }, /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 1.5
  }), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 3,
    className: DateRangeStyles.row__label
  }, /*#__PURE__*/React.createElement(ELSFormLabel, {
    id: "startYearLabel",
    "for": "startYear"
  }, "Publish from"), /*#__PURE__*/React.createElement(ELSNativeSelect, {
    id: "startYear",
    name: "startYear",
    label: "startyear",
    onChange: handleChange,
    className: DateRangeStyles.select,
    value: (quickAndExpertState === null || quickAndExpertState === void 0 ? void 0 : quickAndExpertState.startYear) || getYearRange("asc")[0],
    "aria-label": "Select start year"
    // assigned it the ELSNativeSelect reference :
    ,
    ref: startYearRef
  }, getYearRange("asc").map(function (item) {
    return /*#__PURE__*/React.createElement(ELSNativeSelectOption, {
      key: "startyear-".concat(item),
      value: "".concat(item),
      disabled: item > (quickAndExpertState === null || quickAndExpertState === void 0 ? void 0 : quickAndExpertState.endYear)
    }, item);
  }))), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true,
    xs: 3,
    className: DateRangeStyles.row__label
  }, /*#__PURE__*/React.createElement(ELSFormLabel, {
    id: "endYearLabel",
    "for": "endYear"
  }, "To"), /*#__PURE__*/React.createElement(ELSNativeSelect, {
    id: "endYear",
    name: "endYear",
    label: "endyear",
    onChange: handleChange,
    className: DateRangeStyles.select,
    value: (quickAndExpertState === null || quickAndExpertState === void 0 ? void 0 : quickAndExpertState.endYear) || getYearRange("desc")[0],
    "aria-label": "Select end year"
  }, /*#__PURE__*/React.createElement(ELSNativeSelectOption, {
    key: "startyear-latest",
    value: "*"
  }, "Latest"), getYearRange("desc").map(function (item) {
    return /*#__PURE__*/React.createElement(ELSNativeSelectOption, {
      key: "startyear-".concat(item),
      value: "".concat(item),
      disabled: item < (quickAndExpertState === null || quickAndExpertState === void 0 ? void 0 : quickAndExpertState.startYear)
    }, item);
  }))), /*#__PURE__*/React.createElement(ELSGrid, {
    item: true
  }, /*#__PURE__*/React.createElement(DeleteButton, {
    name: "delete-range-range",
    "aria-label": "delete year range search row",
    onClick: toggleYearRow,
    "data-cy": "delete-year-range"
  })));
}
export default Date;